import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Header from "./Header";
import SideBar from "./SideBar";
import Chart from "chart.js/auto";
import Data from "./Data";
import { CircularProgress } from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroller";
import OwlCarousel from "react-owl-carousel-rtl";
import Masters from "./Masters";
import PaysList from "./PaysList";
import { NavLink } from "react-router-dom";
import { Input, Loading, Button, Spacer, Link } from "@nextui-org/react";
import { useState, useEffect } from "react";
import { BiSearchAlt } from "react-icons/bi";
function Pays(props) {
  const [articles, setArticles] = useState([]);
  const [nextPage, setNextPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [length, setLength] = useState(0);
  const [search, setSearch] = useState("");

  useEffect(function mount() {
    $("#progressTop").addClass("invisible");
    $("#no_item").addClass("invisible");

    // if (articles.length === parseInt(length) && articles.length !== 0){
    //     $('#loading').addClass("invisible")
    // } else {
    //     $('#loading').removeClass("invisible")
    // }
  });

  useEffect(() => {
    setHasMore(length - articles.length > 0);
    console.log(articles.length + " : " + parseInt(length));
    if (articles.length >= parseInt(length) && articles.length !== 0) {
      $("#loading").addClass("invisible");
    } else {
      $("#loading").removeClass("invisible");
    }
  }, [articles]);
  let myRef = null;
  let loader = null;
  const setMyRefRef = (element) => {
    myRef = element;
  };
  const setMyLoader = (element) => {
    loader = element;
  };

  const handlelength = () => {
    setLength(length - 1);
  };

  const handleLoadMore = () => {
    let token = localStorage.getItem("token");
    let data = new FormData();
    data.append("token", token);
    data.append("how", "10");
    data.append("search", search);
    data.append("count", nextPage);
    setHasMore(false);

    axios
      .post(Data.server + `getPays.php`, data)
      .then((response) => {
        console.log("response getPays :", response);
        if (
          response.data.hasOwnProperty("data") &&
          response.data.hasOwnProperty("length") &&
          response.data.hasOwnProperty("row")
        ) {
          const lengthh = response.data.length;
          const { row, data } = response.data;
          setLength(lengthh);
          setNextPage(row);
          setArticles([...articles, ...data]);

          // this.setState(prevState => ({
          //     articles: [...prevState.articles, ...data],
          //     hasMore: length - articles.length > 0,
          //     length: length,
          //     nextPage: row
          // }));
        }
        if (response.data.hasOwnProperty("invalid_token")) {
          props.logout();
        }
        if (response.data.hasOwnProperty("no_item")) {
          $("#no_item").removeClass("invisible");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSearch = (e) => {
    if (e.preventDefault() != undefined) {
      e.preventDefault();
    }

    setArticles([]);
    setNextPage(0);
    setHasMore(true);
    setLength(0);
  };

  const handleChange = (event) => {
    let target = event.target;
    let val = target.value;
    setSearch(val);
  };

  return (
    <div className="container-fluid">
      <SideBar li="paymentspanel" />
      <div className="col-12 bg-light p-4 homee" id="Pays">
        <div className="d-flex justify-content-between align-items-center flex-md-nowrap border-bottom pb-4">
          <h3 className="h5 text-center">{length + " تراکنش"}</h3>

          <form
            onSubmit={handleSearch.bind(this)}
            className="input-group justify-content-center"
          >
            <Input
              clearable
              bordered
              type="text"
              name="search"
              value={search}
              className="m-2"
              color="secondary"
              placeholder="جست و جو ..."
              helperText={"نام , نام خانوادگی یا شماره تلفن"}
              contentRight={
                <div
                  className="circle-background"
                  onClick={handleSearch.bind(this)}
                >
                  <BiSearchAlt />
                </div>
              }
              contentClickable={true}
              onChange={handleChange.bind(this)}
              size="lg"
            />
            <Spacer y={1} />
          </form>
        </div>
        {/* 
                <div className="table-responsive radius">
                    <table className="table table-condensed table-bordered table-striped table-hover text-center">
                
                         <thead>
                        <tr className="table-secondary">
                            <th>نام و نام خانوادگی</th>
                            <th>شماره تلفن</th>
                            <th>کلاس های اینترنتی</th>
                            <th>تاریخ ثبت نام</th>
                            <th>آخرین بازدید</th>
                            <th>IP</th>
                            <th>ویرایش / حذف</th>
                        </tr>
                        </thead>
                        <InfiniteScroll
                            element="tbody"
                            className=""
                            ref={this.setMyLoader}
                            hasMore={hasMore}
                            loadMore={this.handleLoadMore.bind(this)}
                            getScrollParent={() => this.myRef}
                        >

                            {articles.map((products, index) => <PaysList toast={this.handleToast.bind(this)} length={this.handlelength.bind(this)} products={products} index={index}/>)}

                        </InfiniteScroll>

                    </table>
                    <div id="loading" className="mr-auto ml-auto mt-2 text-muted text-center">
                        <h3 className="h3">در حال بارگذاری ...</h3>
                        <CircularProgress color="secondary"/>
                    </div>
                </div> */}

        <InfiniteScroll
          element="div"
          className="row mt-4"
          ref={setMyLoader}
          hasMore={hasMore}
          loadMore={handleLoadMore.bind(this)}
          getScrollParent={() => myRef}
        >
          {articles.map((products, index) => (
            <PaysList
              length={handlelength.bind(this)}
              products={products}
              key={index}
              index={index}
            />
          ))}
        </InfiniteScroll>
        <div
          id="loading"
          className="mr-auto ml-auto mt-2 text-muted text-center"
        >
          <Loading color="secondary" size="xl">
            در حال بارگزاری ...
          </Loading>
        </div>
      </div>
    </div>
  );
}

export default Pays;
